<template lang="pug">
div
	transition(name="fadeLoading")
		Loading(v-show="isActiveLoading")
	Maintenance(v-if="showMaintenancePopup")
	router-view(v-slot="{ Component }")
		transition(name="fade")
			component(:is="Component")
</template>

<script>
	import Loading from "@/components/Loading/index.vue";
	import Maintenance from "@/components/Maintenance/index.vue";
	import { nextTick } from "vue";

	export default {
		components: {
			Loading,
			Maintenance,
		},
		computed: {
			isActiveLoading() {
				return this.$store.state.isActiveLoading;
			},
			showMaintenancePopup() {
				return this.$store.state.showMaintenancePopup;
			},
		},
		mounted() {
			nextTick(() => {
				let vm = this;
				const params = new URLSearchParams(window.location.search);
				if (params.get('bypass') === 'nb2026test') {
					sessionStorage.setItem('maintenanceBypass', '1');
				}
				vm.$store.dispatch("initLineLiff");
				let vh = window.innerHeight * 0.01;
				document.documentElement.style.setProperty("--vh", `${vh}px`);
			});
		},
	};
</script>

<style lang="sass">
	@import "@/assets/sass/_reset.sass"
	@import "@/assets/sass/_variable.sass"
	@import "@/assets/sass/_mixin.sass"
	@import "@/assets/sass/_layout.sass"
</style>
